import { FlexProps } from 'UIKit/Box/types'
import IconButton from 'UIKit/Button/IconButton'
import Text from 'UIKit/Text'
import { APIEndpointEnum } from 'config/constants/server'
import { useCountDown } from 'hooks/useCountdown'
import { RowMiddle } from 'layout/Components/Row'
import React, { useCallback, useState } from 'react'
import { Trans } from 'react-i18next'
import { Icons } from 'svgs'
import { formatFitlerTransaction } from 'utils/transaction'
import { exportDataByUrl } from 'utils/urlHelper'
import { HistoryTransactionFilters } from '../types'

interface DownloadButtonProps extends FlexProps {
  api: APIEndpointEnum
  filters: HistoryTransactionFilters
  disabled?: boolean
}

const DownloadButton: React.FC<DownloadButtonProps> = ({ api, filters, disabled, ...props }) => {
  const [preventDownload, setPreventDownload] = useState(false)

  const timeLeftPreventDownLoad = useCountDown(
    preventDownload ? Date.now() + 30000 : 0,
    (s, m) => `(${s + m * 60})`,
    () => {
      setPreventDownload(false)
    },
  )

  const handleExport = useCallback(async () => {
    if (preventDownload || disabled) return
    setPreventDownload(true)

    const _filters = {}
    const formatFilter = formatFitlerTransaction(filters, api === APIEndpointEnum.ExportDepositHistory)

    Object.keys(formatFilter).forEach((key) => {
      if (formatFilter[key]) {
        _filters[key] = formatFilter[key]
      }
    })

    exportDataByUrl(new URL(`${window.location.origin}/${api}`).toString(), _filters)
  }, [filters, disabled])

  const isDisabled = disabled || preventDownload

  return (
    <RowMiddle {...props}>
      <IconButton
        disabled={isDisabled}
        onClick={handleExport}
        style={{
          opacity: isDisabled ? 0.3 : 1,
          cursor: isDisabled ? 'not-allowed' : 'pointer',
        }}
      >
        <RowMiddle>
          <Icons.DownloadIcon />
          <Text bold small ml="8px">
            <Trans>Export</Trans>
          </Text>
        </RowMiddle>
      </IconButton>

      {preventDownload && (
        <>
          <Text
            minWidth="24px"
            ml="4px"
            fontSize="12px"
            color="textSubtle"
            textAlign="center"
            ref={timeLeftPreventDownLoad}
          />
        </>
      )}
    </RowMiddle>
  )
}

export default DownloadButton
